import { Component, OnInit, OnDestroy, Type, ViewChild, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxCheckBoxModule, DxDataGridComponent, DxDataGridModule, DxPopupModule, DxSelectBoxModule, DxTextBoxModule, DxValidatorModule, } from 'devextreme-angular';
import { TechnicalComponentsService } from 'src/app/services/tech-components.service';
import { AppGlobals } from 'src/app/app.globals';
import { name } from 'node_modules/@azure/msal-angular/packageMetadata';
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";

import { ActivityLogService } from 'src/app/services/activity-log.service';
import { ActivitySection } from 'src/app/constants/activity-log';
import { SearchableDropdownDirective } from '../../../../directives/searchable-dropdown.directive';
import { SvgIconComponent } from "src/app/components/svg-icon/svg-icon.component";
@Component({
    selector: 'app-config-technical-components.page',
    imports: [
    SvgIconComponent,DxSelectBoxModule, DxButtonModule, DxTextBoxModule, DxDataGridModule, DxCheckBoxModule, DxPopupModule, CommonModule, DxValidatorModule, GpdButtonComponent, SearchableDropdownDirective],
    templateUrl: './config-technical-components.page.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './config-technical-components.page.css'
})
export class ConfigTechincalComponentsComponent implements OnInit, OnDestroy {

  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild(DxDataGridComponent, { static: false }) docDataGrid: DxDataGridComponent;
  @ViewChild('datagrid', { static: false }) datagrid: DxDataGridComponent;
  @ViewChild('docDatagrid', { static: false }) docDatagrid: DxDataGridComponent;

  private lastScrollY: number = 0;
  private scrollCount: number = 0;
  private scrollListener: (() => void) | null = null;

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.updateHeaderFilterPosition();
  }

  private updateHeaderFilterPosition(): void {
    const headerFilterPopup = document.querySelector('.dx-header-filter-menu .dx-overlay-content') as HTMLElement;
    const scrollDelta = window.scrollY - this.lastScrollY;

    if (headerFilterPopup && headerFilterPopup.style.top) {
      // Adjust the popup position to scroll with the page
      const currentTop = parseFloat(headerFilterPopup.style.top);
      headerFilterPopup.style.top = (currentTop - scrollDelta) + 'px';
    }

    this.lastScrollY = window.scrollY;
  }

  ngOnDestroy(): void {
    if (this.scrollListener) {
      document.removeEventListener('scroll', this.scrollListener, true);
    }
  }


  showDataDataGrid: boolean = true;
  showDocumentsDataGrid: boolean = true;
  dataTypeName: string = '';
  isAddPopupVisible: boolean = false;
  showDataTypeForm: boolean = false;
  selectedDataType: string = '';
  isMandatory: boolean = false;
  showInTable: boolean = false;
  isRequired: boolean = false;
  dataName: string = '';
  whereAllowedIn: string = '';
  selectedAllowedInId: number | null = null;
  selectedComponentTypeId: number | null = null;
  addDocumentForm: boolean = false;
  docName: string = '';
  docMandatory: boolean = false;
  showGeneralForm: boolean = false;
  enableAddData: boolean = false;
  enableAddDocument: boolean = false;
  enableDeleteButton: boolean = false;
  allDocList: any = [];
  componentTypeDataList: any = [];
  showDropDown: boolean = false;
  optionNum: number = 1; // This can be dynamically set based on the number of options
  noDataText: string = '';
  filteredDataFieldTypes: any = [];
  filteredDocumentTypes: any = [];
  editDataType: boolean = false;
  showDeleteRestrictionPopup: boolean = false;
  hideSaveButton: boolean = true;
  inValidEntryAddComponent: boolean = false;
  isEdit: boolean = false;
  selectedComponentTypeName: string = '';
  showErrMsg: boolean = false;
  errMsg: string = '';
  showDeleteConfirmationPopup: boolean = false;
  datafieldHasComponents: boolean = false;
  componentTypeIdDelete: number = 0;
  IdDelete: number = 0;



  allowedInList: any = [
    { id: 1, name: $localize`:@@project:project`.toUpperCase(), value: 'project' },
    { id: 2, name: $localize`:@@site:site`.toUpperCase(), value: 'gridconnection' },
    { id: 3, name: $localize`:@@all:all`.toUpperCase(), value: 'all' }
  ];

  dataTypeOptions: any = [
    { id: 1, name: $localize`:@@text:Text`.toUpperCase() },
    { id: 2, name: $localize`:@@contact:Contact`.toUpperCase() },
    { id: 3, name: $localize`:@@number:Number`.toUpperCase() },
    { id: 4, name: $localize`:@@dropdown:dropdown`.toUpperCase() },
  ];

  componentTypeList: any = [];

  constructor(readonly componentService: TechnicalComponentsService, private activityLog: ActivityLogService) {

  }

  ngOnInit(): void {
    this.activityLog.logView({ Section: ActivitySection.CONFIG_COMPONENTS });
    this.loadData();
    this.lastScrollY = window.scrollY;

    this.scrollListener = () => {
      const headerFilterPopup = document.querySelector('.dx-overlay-content.dx-popup-normal.dx-resizable.dx-dropdowneditor-overlay') as HTMLElement;
      if (headerFilterPopup) {
        this.scrollCount++;
        if (this.scrollCount > 1) {
          const wrapper = headerFilterPopup.closest('.dx-overlay-wrapper');
          if (wrapper) {
            wrapper.remove();
          } else {
            headerFilterPopup.remove();
          }
          this.scrollCount = 0;
        }
      } else {
        this.scrollCount = 0;
      }
    };
    document.addEventListener('scroll', this.scrollListener, true);
  }



  loadData(): void {
    this.getAllTechComponentTypes();
    this.getDocumentList();
    this.getAllComponentTypeDataField();
    this.noDataTextRuleCheck();
  }

  noDataTextRuleCheck(): void {
    if (this.selectedComponentTypeId == null) {
      this.noDataText = $localize`:@@noDataTextComponents:Please select a component to view data`;
    } else if (this.selectedComponentTypeId !== null && this.filteredDataFieldTypes.length === 0) {
      this.noDataText = $localize`:@@noData:No Data`;
    }
  }




  addTechComponentType(e: any): void {
    const payload = {
      Name: this.dataTypeName,
      AllowedIn: e.selectedItem.name,
    }
    this.componentService.addTechComponentType(payload).then(
      (result => {
        if (result.hasError) {
          console.log(result.feedback);
        }
        console.log(result);
      }));
  }

  onDataTypeSelection(event: any): void {
    console.log('Selected Data Type:', event.selectedItem);
    this.selectedDataTypeId = event.selectedItem.id;
    console.log('Selected Data Type ID:', this.selectedDataTypeId);
    this.selectedDataType = event.selectedItem.name;
    this.showDropDown = event.selectedItem.name === 'DROPDOWN' || event.selectedItem.name === 'dropdown';
  }

  closeAddPopup(): void {
    this.isAddPopupVisible = false;
    this.dataTypeName = '';
    this.selectedAllowedInId = null;
    this.selectedComponentTypeId = null;
    this.inValidEntryAddComponent = false;

  }

  cancelButtonVisible: boolean = true;
  cancelEditOrCreate(): void {
    if (this.selectedComponentTypeId && this.isEdit) {
      this.cancelButtonVisible = false;
      this.nameBoxDisabled = true;
      this.hideSaveButton = true;
      this.inValidEntryAddComponent = false;
    }
    else if (!this.selectedComponentTypeId) {
      this.cancelButtonVisible = false;
      this.showGeneralForm = false;
      this.dataTypeName = '';
      this.selectedAllowedInId = null;
      this.selectedComponentTypeId = null;
      this.enableAddData = false;
      this.enableAddDocument = false;
      this.enableDeleteButton = false;
      this.filteredDataFieldTypes = [];
      this.filteredDocumentTypes = [];
      this.inValidEntryAddComponent = false;
    }
  }

  closeAddDataPopup(): void {
    this.showDataTypeForm = false;
    this.dataName = '';
    this.selectedDataType = '';
    this.isMandatory = false;
    this.showInTable = false;
    this.isRequired = false;
  }

  confirmAddComponent(): void {
    this.inValidEntryAddComponent = false;

    if (this.dataTypeName == '' || this.dataTypeName == null) {
      this.inValidEntryAddComponent = true;
      return;

    }
    this.isAddPopupVisible = false;
    this.showGeneralForm = true;
    this.enableDeleteButton = false;
    this.enableAddData = false;
    this.enableAddDocument = false;
    this.hideSaveButton = false;
    this.nameBoxDisabled = false;
    this.inValidEntryAddComponent = false;
    this.cancelButtonVisible = true;
  }

  closeDocumentForm(): void {
    this.addDocumentForm = false;
    // Reset any other fields if necessary
    this.editDocType = false;
    this.selectedDocId = null;
    this.docName = '';
    this.docMandatory = false;
  }


  onComponentSelect(event: any): void {
    this.isAddPopupVisible = false;
    this.datafieldHasComponents = false;
    this.documentHasComponents = false;
    this.showDataTypeForm = false;
    this.addDocumentForm = false;
    this.noDataTextRuleCheck();
    this.cancelButtonVisible = false;
    const whereAllowed = event.selectedItem.allowedIn;
    this.dataTypeName = event.selectedItem.name;
    this.selectedComponentTypeId = event.selectedItem.id;
    this.selectedComponentTypeName = event.selectedItem.name; // <-- Set here if you want
    const match = this.allowedInList.find(item => item.value === whereAllowed);
    this.selectedAllowedInId = match ? match.id : null;
    this.showGeneralForm = true;
    this.nameBoxDisabled = true;
    this.enableAddData = true;
    this.enableAddDocument = true;
    this.enableDeleteButton = true;
    this.getDatafieldbyId();
    this.getDocsbyId();
    this.hideSaveButton = true;
  }

  onAddClick(): void {
    this.datafieldHasComponents = false;
    this.documentHasComponents = false;
    this.dataTypeName = '';
    this.selectedAllowedInId = null;
    this.selectedComponentTypeId = null;
    this.nameBoxDisabled = false;
    this.hideSaveButton = false;
    this.showGeneralForm = false;
    this.selectedDataType = '';
    this.inValidEntryAddComponent = false;
    this.cancelButtonVisible = true;
    this.isEdit = false;
    this.showDataTypeForm = false;
    this.editDataType = false;
    this.dataName = '';
    this.isMandatory = false;
    this.showInTable = false;
    this.optionFields = [''];
    this.enableAddData = false;
    this.enableAddDocument = false;
    this.enableDeleteButton = false;
    this.filteredDataFieldTypes = [];
    this.filteredDocumentTypes = [];
    this.enableAddDocument = false;
    this.addDocumentForm = false;
    this.showDeleteConfirmationPopup = false;
    setTimeout(() => {
      this.isAddPopupVisible = true;
    }, 100);
  }

  nameBoxDisabled: boolean = true;
  editComp(): void {
    this.hideSaveButton = false;
    this.nameBoxDisabled = false;
    this.isEdit = true;
    this.cancelButtonVisible = true;
  }


  addTechComponentTypeData(): void {
    const payload = {
      ComponentTypeId: this.selectedComponentTypeId,
      Name: this.dataName,
      Type: this.selectedDataType, // This should be dynamic based on user selection
      Required: this.isMandatory, // This should be dynamic based on user selection
      ShowInTable: this.showInTable,// This should be dynamic based on user selection
      UserDefinedSelectionOptions: this.optionFields.length ? JSON.stringify(this.optionFields) : null,
    };
    if (!this.dataName || !this.selectedDataType) {
      // Handle validation error
      console.error('Data name and type are required');
      return;
    } else {
      this.componentService.addTechComponentTypeData(payload).then(
        (result => {
          if (result.hasError === true) {
            this.showErrMsg = true;
            this.errMsg = result.feedback;
          } else {
            this.closeAddDataPopup();
            this.getAllComponentTypeDataField();
            this.getDatafieldbyId();

          }
        })
      );

    }
  }

  getAllTechComponentTypes(): void {
    this.componentService.getAllTechComponentTypes({}).then(result => {
      this.componentTypeList = result.componentTypeList.map(item => ({
        ...item,
        name: item.name
      })).sort((a, b) => a.name.localeCompare(b.name));
    });
  }




  showAllowedInError: boolean = false;

  saveTechComponentType(): void {
    this.showAllowedInError = false;
    this.inValidEntryAddComponent = false;

    // Validate name
    if (this.dataTypeName == '' || this.dataTypeName == null) {
      this.inValidEntryAddComponent = true;
      this.showDataNameError = false;
      return;
    }

    // Validate allowed type
    if (this.selectedAllowedInId == null) {
      this.showAllowedInError = true;
      this.inValidEntryAddComponent = false;
      return;
    }

    // If any error, stop
    if (this.inValidEntryAddComponent || this.showAllowedInError) {
      return;
    }
    this.showAllowedInError = false;
    this.inValidEntryAddComponent = false;

    const allowedInObj = this.allowedInList.find(item => item.id === this.selectedAllowedInId);

    const payload = {
      Name: this.dataTypeName,
      AllowedIn: allowedInObj ? allowedInObj.value : null,
      id: this.selectedComponentTypeId // Use the selected ID for editing
    };

    if (this.selectedComponentTypeId) {
      // Edit existing
      this.componentService.editTechComponentType(payload).then(result => {
        if (result.hasError) {
          this.showErrMsg = true;
          this.errMsg = result.feedback;
          this.dataTypeName = this.selectedComponentTypeName;
        } else {
          this.getAllTechComponentTypes();
        }
      });
    } else {
      // Add new
      this.componentService.addTechComponentType(payload).then(result => {
        if (result.hasError) {
          console.log(result.feedback);
          this.showErrMsg = true;
          this.errMsg = result.feedback;
        }
        this.componentService.getAllTechComponentTypes({}).then(result => {
          this.componentTypeList = result.componentTypeList.map(item => ({
            ...item,
            name: item.name
          }));
          setTimeout(() => {
            const selected = this.componentTypeList.find(
              item => item.name === this.dataTypeName
            );
            if (selected) {
              this.selectedComponentTypeId = selected.id;
              this.onComponentSelect({ selectedItem: selected });
            }
          }, 2000);
        });
      });
    }
    this.hideSaveButton = true;
    this.nameBoxDisabled = true;

    this.showAllowedInError = false;
    this.inValidEntryAddComponent = false;
  }

  showDataNameError: boolean = false;
  showDataTypeError: boolean = false;
  saveTechComponentTypeData(e: any): void {
    this.showDataNameError = false;
    this.showDataTypeError = false;
    if ((this.dataName === '' || this.dataName == null) && (this.selectedDataTypeId == null)) {
      this.showDataNameError = true;
      this.showDataTypeError = true;
      console.log('Both errors shown');
      return;
    } else if (this.dataName === '' || this.dataName == null) {
      this.showDataNameError = true;
      this.showDataTypeError = false;
      console.log('Data Name error shown');
      return;
    } else if (this.selectedDataTypeId == null) {
      this.showDataTypeError = true;
      this.showDataNameError = false;
      console.log('Data Type error shown');
      return;
    }

    this.blankOptionIndex = null;
    if (
      this.selectedDataType &&
      (this.selectedDataType.toLowerCase() === 'dropdown')
    ) {
      for (let i = 0; i < this.optionFields.length; i++) {
        if (!this.optionFields[i] || this.optionFields[i].trim() === '') {
          this.blankOptionIndex = i;
          console.log('Blank option at index:', this.blankOptionIndex);
          return;
        }
      }
    }

    if (this.editDataType) {
      this.editDataTypeField();
      this.editDataType = false;
    } else {

      this.addTechComponentTypeData();
    }

  }

  onAllowedInChanged(e: any): void {
    this.selectedAllowedInId = e.value;
  }


  addDocument(): void {
    const payload = {
      Name: this.docName,
      Required: this.docMandatory,
      TechComponentTypeId: this.selectedComponentTypeId
    }
    this.componentService.addComponentTypeDocs(payload).then(
      (result => {
        if (result.hasError === true) {
          this.showErrMsg = true;
          this.errMsg = result.feedback;
        } else {
          this.closeDocumentForm();
          this.getDocumentList();
          this.getDocsbyId();
        }
      })
    );
  }

  editDocType: boolean = false;
  selectedDocId: number | null = null;
  selectedDocName: string = '';
  selectedDocRequired: boolean = false;
  selectedDocTCId: number | null = null;
  editDocRow(data: any): void {
    const docData = data.data;
    this.editDocType = true;
    this.addDocumentForm = true;

    this.selectedDocId = docData.id;
    this.docName = docData.name;
    this.docMandatory = docData.required;
    this.selectedDocTCId = docData.techComponentId;
  }

  editDoc(): void {
    const payload = {
      Id: this.selectedDocId,
      Name: this.docName,
      Required: this.docMandatory,
      TechComponentId: this.selectedDocTCId
    }
    this.componentService.editComponentTypeDocs(payload).then(
      (result => {

        this.addDocumentForm = false;
        this.editDocType = false;
        this.getDocumentList();
        this.getDocsbyId();
      })
    );
  }

  showDocNameError: boolean = false;
  saveDocument(): void {
    if (this.docName === '' || this.docName == null) {
      this.showDocNameError = true;
      return;
    }

    if (this.editDocType) {
      this.editDoc();
    } else {
      this.addDocument();
    }
  }


  getDocumentList(): void {

    this.componentService.getComponentTypeDocs({}).then(
      (result => {
        this.allDocList = result.documents;
      })
    );
  }

  getAllComponentTypeDataField(): void {
    this.componentService.getAllComponentTypeDataField({}).then(
      (result => {
        this.componentTypeDataList = result.componentTypeDataList;
        this.datagrid.instance.refresh(); // Refresh the grid after fetching data
      })
    );
  }

  optionFields: string[] = [''];
  showBlankOptionError: boolean = false;
  blankOptionIndex: number | null = null;
  onAddOption(): void {
    this.blankOptionIndex = null;
    for (let i = 0; i < this.optionFields.length; i++) {
      if (!this.optionFields[i] || this.optionFields[i].trim() === '') {
        this.blankOptionIndex = i;
        return;
      }
    }
    this.optionFields.push('');
  }

  selectedDataTypeId: number = null;
  datatypeId: number = null;
  editRow(data: any): void {
    const dfData = data.data;
    this.datatypeId = dfData.id;
    this.editDataType = true;
    this.showDataTypeForm = true;
    this.dataName = dfData.name;

    console.log('Data Field Data:', dfData);
    console.log('Data Type Options:', this.dataTypeOptions);
    // Find the matching type option
    const matchedType = this.dataTypeOptions.find(opt => opt.name.toUpperCase() === dfData.type.toUpperCase());
    this.selectedDataTypeId = matchedType?.id ?? null;
    this.selectedDataType = matchedType?.name ?? '';

    this.showDropDown = matchedType?.name === 'DROPDOWN' || matchedType?.name === 'dropdown';
    console.log('Matched Type:', matchedType);
    this.isMandatory = dfData.required;
    this.showInTable = dfData.showInTable;

    // Parse userDefinedOptionList correctly
    let options = [];
    if (dfData.userDefinedOptionList && Array.isArray(dfData.userDefinedOptionList) && dfData.userDefinedOptionList.length > 0) {
      try {
        options = JSON.parse(dfData.userDefinedOptionList[0]);
      } catch {
        options = [];
      }
    }
    this.optionFields = options.length ? options : [''];
  }



  editDataTypeField(): void {
    const payload = {
      Id: this.datatypeId,
      ComponentTypeId: this.selectedComponentTypeId,
      Name: this.dataName,
      Type: this.selectedDataType, // id of the selected type
      Required: this.isMandatory,
      SelectedTypeId: this.selectedDataTypeId,
      ShowInTable: this.showInTable,
      UserDefinedSelectionOptions: this.optionFields.length ? JSON.stringify(this.optionFields) : null,
    };
    this.componentService.editTechComponentTypeDataField(payload).then(
      (result => {
        this.showDataTypeForm = false;
        this.getAllComponentTypeDataField();
        this.getDatafieldbyId()
      })
    );
  }

  deleteDataTypeField(): void {
    const payload = {
      ComponentTypeId: this.componentTypeIdDelete,
      Id: this.IdDelete
    };
    this.componentService.deleteTechComponentTypeDataField(payload).then(
      (result => {
        if (result.hasError === true) {
          this.showErrMsg = true;
          this.errMsg = result.feedback;
        } else {
          this.getAllComponentTypeDataField();
          this.getDatafieldbyId();
          this.datafieldHasComponents = false;
          this.errMsg = '';
        }
      })
    );
  }

  deleteDocument(): void {
    const payload = {
      ComponentTypeId: this.componentTypeIdDelete,
      Id: this.IdDelete
    };
    this.componentService.deleteTechComponentTypeDocument(payload).then(
      (result => {
        this.getDocumentList();
        this.getDocsbyId();
        this.addDocumentForm = false;
        this.documentHasComponents = false;
      })
    );
  }


  datafieldDeleteCheck(data: any): void {
    const payload = {
      ComponentTypeId: this.selectedComponentTypeId,
      Id: data.data.id
    };
    this.componentTypeIdDelete = this.selectedComponentTypeId;
    this.IdDelete = data.data.id;
    this.componentService.deleteDatafieldCheck(payload).then(
      (result => {
        if (result.hasError === true) {
          this.datafieldHasComponents = true;
          this.errMsg = result.feedback;
        }
        else {
          this.deleteDataTypeField();
        }
      })
    );
  }

  documentHasComponents: boolean = false;
  deleteDocumentTypeCheck(data: any): void {
    const payload = {
      ComponentTypeId: this.selectedComponentTypeId,
      Id: data.data.id
    };
    this.componentTypeIdDelete = this.selectedComponentTypeId;
    this.IdDelete = data.data.id;
    this.componentService.deleteDocumentTypeCheck(payload).then(
      (result => {
        if (result.hasError === true) {
          this.documentHasComponents = true;
          this.errMsg = result.feedback;
        }
        else {
          this.deleteDocument();
        }
      })
    );
  }


  

  cancelDeleteProcess(): void {
    this.datafieldHasComponents = false;
    this.errMsg = '';
    this.documentHasComponents = false;
  }

  deleteTechComponentType(): void {
    this.showDeleteConfirmationPopup = false;
    const payload = {
      Id: this.selectedComponentTypeId
    };
    this.componentService.deleteTechComponentType(payload).then(
      (result => {
        if (result.hasError === true) {
          this.showDeleteRestrictionPopup = true;
          this.errMsg = result.feedback;
        }
        else {
          this.loadData();
          this.selectedComponentTypeId = null;
          this.dataTypeName = '';
          this.showGeneralForm = false;
          this.enableAddData = false;
          this.enableAddDocument = false;
          this.enableDeleteButton = false;
          this.filteredDataFieldTypes = [];
          this.filteredDocumentTypes = [];
          this.showDeleteConfirmationPopup = false;
        }
      })
    );
  }

  closeRestrictedPopup(): void {
    this.errMsg = '';
    this.showDeleteRestrictionPopup = false;
  }

  selectedComponent: any = {};
  datafieldSelected: any = {};
  getDatafieldbyId(): void {
    this.componentService.getTypeFieldById({ Id: this.selectedComponentTypeId }).then(
      (result => {
        // In getDatafieldbyId()
        // const nameField = {
        //   name: $localize`:@@name:name`,
        //   type: 'Text',
        //   required: true,
        //   value: this.selectedComponent?.name || '',
        //   readOnly: true,
        //   isSystemField: true
        // };
        const modelField = {
          name: $localize`:@@model:model`,
          type: 'TEXT',
          required: true,
          value: this.selectedComponent?.model || '',
          readOnly: true,
          isSystemField: true
        };
        const manufacturerField = {
          name: $localize`:@@manufacturer:Manufacturer`,
          type: 'KONTAKT',
          required: true,
          value: this.selectedComponent?.manufacturer || '',
          readOnly: true,
          isSystemField: true
        };
        this.datafieldSelected = [
          modelField,
          manufacturerField,
          ...(result.componentTypeDataList || [])
        ];
        this.filteredDataFieldTypes = this.datafieldSelected;
      })
    );
  }

  docSelected: any = {};
  getDocsbyId(): void {
    this.componentService.getDocsById({ Id: this.selectedComponentTypeId }).then(
      (result => {
        this.docSelected = result.documents;
        this.filteredDocumentTypes = this.docSelected;
      })
    );
  }

  onDeleteOption(i: any): void {
    this.optionFields.splice(i, 1);
  }

  openDataTypeForm(): void {
    this.datafieldHasComponents = false;
    this.documentHasComponents = false;
    this.showDataTypeForm = true;
    this.dataName = '';
    this.selectedDataType = '';
    this.isMandatory = false;
    this.showInTable = false;
    this.isRequired = false;
    this.optionFields = [''];
    this.showDataNameError = false;
    this.showDataTypeError = false;
    this.editDataType = false;
    this.selectedDataTypeId = null;
    this.showDropDown = false;
  }

  get deleteConfirmationMessage(): string {
    return $localize`:@@deleteComponentTypeConfirmation:Are you sure you want to delete ${this.selectedComponentTypeName}?`;
  }

  openDocumentForm(): void {
    this.addDocumentForm = true;
    this.datafieldHasComponents = false;
    this.documentHasComponents = false;
    this.docName = '';
    this.docMandatory = false;
    this.showDocNameError = false;
  }
}
